import { WRAPPER } from '@/shared/styles/themes';
import styled, { css } from 'styled-components';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

export const Wrapper = styled.div`
  display: flex;
  //margin-top: 8px;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  height: 42px;
  //margin-bottom: 32px;

  @media (max-width: 768px) {
    //margin-top: 18px;
    margin-left: 18px;
    margin-right: 18px;
    //padding: 0 18px;
    //  margin: 0;

    ${brandIsPh &&
    css`
      margin-left: 12px;
      margin-right: 12px;
    `}
  }

  ${({ $alignToLeft }) =>
    $alignToLeft &&
    `
      
      @media (max-width: 768px) {
        margin: 0;
      }
    `}
`;

export const SearchWrapper = styled.div`
  //flex-basis: 313px;
    flex: 1;

  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    gap: 6px;
    position: relative;
    /* margin-bottom: 6px; */
    flex-basis: 0;
  }
`;

export const SelectsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 6px;
  }
`;

export const DeleteFilterWrapper = styled.div`
  ${WRAPPER};
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    //margin-top: 12px;
    margin: 0 18px;
    justify-content: center;
    max-height: 42px;

    ${brandIsPh &&
    css`
      margin: 0 12px;
    `}
  }
`;

export const SearchButtonWrapper = styled.div`
  @media (max-width: 768px) {
    ${brandIsPh &&
    css`
      button {
        background: linear-gradient(89deg, #ff9500 0.66%, #ff5e00 116.39%);
      }
    `}
  }
`;

const MOBILE_SKELETON_MEDIA =
  '@media (orientation: portrait) and (max-width: 768px), (orientation: landscape) and (max-width: 1024px)';

export const DesktopSkeletonWrapper = styled.div`
  display: contents;

  ${MOBILE_SKELETON_MEDIA} {
    display: none;
  }
`;

export const MobileSkeletonRow = styled.div`
  display: none;
  width: 100%;
  align-items: center;
  gap: 8px;

  ${MOBILE_SKELETON_MEDIA} {
    display: flex;
    margin-bottom: 6px;
  }
`;

export const MobileSkeletonControls = styled.div`
  display: grid;
  gap: 8px;
  flex-shrink: 0;
  grid-template-columns: ${brandIsPh ? '42px 42px' : '62.5px 1fr'};
`;

export const MobileSkeletonDeleteFilterWrapper = styled(DeleteFilterWrapper)`
  display: none;

  ${MOBILE_SKELETON_MEDIA} {
    display: flex;
  }
`;
